module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-1",
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("The Life Drawing Club")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("The three of us were mates")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Have been for many years.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("So, when asked to pose for model’s rates,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We took the money and the jeers.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The evening arrived all too soon")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We chose the clothes we would model with care.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We all assembled in a tiny room")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And were told, ‘No clothes, you’ll all be bare.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("‘Bare!’ we shrieked. ‘What, in the nude? That never was the deal.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But the lady in charge said,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘Get them off and I’m not being crude.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("This is life drawing; we all know how you feel.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We posed two hours, with our butts on display")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Too nervous to show all we’d got.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Then someone shouted,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘Turn them around the other way.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘My God, you all look pretty hot.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The evening was a roaring success")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And we were all asked to ‘Come next week’.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We looked at each other but no one said yes.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("It was NOT a job for the quiet or the meek.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9723f9be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398418653_EPUB-4.vue
// module id = 69
// module chunks = 0